const EYES_IMG =
    "https://static.prod-images.emergentagent.com/jobs/af7c0393-c056-4b66-995a-3d466ef89518/images/c6b14c988e1430212841d19082f63ec12e54f9c445b63df991e1b4c4803e0f72.jpeg";

export function CampaignBanner() {
    return (
        <section
            className="campaign-banner w-full"
            data-testid="campaign-banner"
            aria-label="Caprio Knows campaign"
        >
            <div
                className="campaign-eyes relative"
                style={{ backgroundImage: `url(${EYES_IMG})` }}
            >
                <div className="relative z-10 mx-auto max-w-7xl px-6 py-14 sm:py-20 lg:py-24">
                    <div className="max-w-3xl">
                        <h2
                            className="font-condensed uppercase leading-[0.92] text-[15vw] sm:text-7xl lg:text-8xl"
                            style={{ color: "var(--ck-ivory)" }}
                        >
                            Caprio Knows<span style={{ color: "var(--ck-gold)" }}>.</span>
                        </h2>
                        <p
                            className="font-condensed uppercase mt-5 text-lg sm:text-2xl lg:text-3xl leading-snug"
                            style={{ color: "var(--ck-ivory)", letterSpacing: "0.02em" }}
                        >
                            Caprio knows music<span style={{ color: "var(--ck-gold)" }}>.</span>{" "}
                            Caprio knows culture<span style={{ color: "var(--ck-gold)" }}>.</span>{" "}
                            Caprio knows curiosity<span style={{ color: "var(--ck-gold)" }}>.</span>
                        </p>
                    </div>
                    <div className="mt-10 sm:absolute sm:bottom-8 sm:right-8 sm:mt-0">
                        <p
                            className="tracking-label text-[10px] sm:text-xs font-semibold text-right leading-relaxed"
                            style={{ color: "var(--ck-gold)" }}
                        >
                            Same questions.
                            <br />A brighter world.
                        </p>
                        <div className="gold-rule ml-auto mt-2" />
                    </div>
                </div>
            </div>
        </section>
    );
}
